module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/osOY8scaYSlkkOstJmTQv-c27806da05ecc53877af6f30e0ced373.jpg";